// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepper-wrapper {
  display: flex;
  justify-content: space-between;
  height: 82vh;
  overflow-x: hidden;
}

.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  border: 0.5px solid rgba(200, 197, 197, 0.2196078431);
}
@media (max-width: 768px) {
  .stepper-item {
    font-size: 12px;
  }
}

.cursor {
  cursor: pointer;
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 39px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 39px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}
.stepper-item .step-counter .content {
  justify-content: left;
  align-items: start;
}

.stepper-item.active {
  font-weight: bold;
}

.stepper-item.Success .step-counter {
  background-color: #4bb543;
}

.stepper-item.Success::after {
  position: absolute;
  content: "";
  border-bottom: 3px solid #4bb543;
  width: 100%;
  top: 39px;
  left: 50%;
  z-index: 3;
}

.stepper-item.Inprogress .step-counter {
  background-color: goldenrod;
}

.stepper-item.Inprogress::after {
  position: absolute;
  content: "";
  border-bottom: 3px solid goldenrod;
  width: 100%;
  top: 39px;
  left: 50%;
  z-index: 3;
}

.stepper-item.Failed .step-counter {
  background: red;
}

.stepper-item.Failed::after {
  position: absolute;
  content: "";
  border-bottom: 3px solid red;
  width: 100%;
  top: 39px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}

.stepper-item:last-child::after {
  content: none;
}

.dialog-background {
  background-color: gray;
  opacity: 0.2 !important;
}

.list_item {
  width: 85%;
}`, "",{"version":3,"sources":["webpack://./src/app/diagnosis/diagnosis.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;AACF;;AACA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;EACA,qDAAA;AAEF;AADG;EAPH;IAQI,eAAA;EAIF;AACF;;AAFA;EACE,eAAA;AAKF;;AAHA;EACE,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAMF;;AAHA;EACE,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAMF;;AAHA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAMF;AALE;EACE,qBAAA;EACA,kBAAA;AAOJ;;AADA;EACE,iBAAA;AAIF;;AADA;EACE,yBAAA;AAIF;;AADA;EACE,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAIF;;AAFA;EACE,2BAAA;AAKF;;AAFA;EACE,kBAAA;EACA,WAAA;EACA,kCAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAKF;;AAHA;EACE,eAAA;AAMF;;AAHA;EACE,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAMF;;AAHA;EACE,aAAA;AAMF;;AAJA;EACE,aAAA;AAOF;;AAJA;EACE,sBAAA;EACA,uBAAA;AAOF;;AAHA;EACE,UAAA;AAMF","sourcesContent":[".stepper-wrapper {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  height: 82vh;\r\n  overflow-x: hidden;\r\n}\r\n.stepper-item {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  flex: 1;\r\n  border: 0.5px solid #c8c5c538;\r\n   @media (max-width: 768px) {\r\n    font-size: 12px;\r\n   }\r\n}\r\n.cursor {\r\n  cursor: pointer;\r\n}\r\n.stepper-item::before {\r\n  position: absolute;\r\n  content: \"\";\r\n  border-bottom: 2px solid #ccc;\r\n  width: 100%;\r\n  top: 39px;\r\n  left: -50%;\r\n  z-index: 2;\r\n}\r\n\r\n.stepper-item::after {\r\n  position: absolute;\r\n  content: \"\";\r\n  border-bottom: 2px solid #ccc;\r\n  width: 100%;\r\n  top: 39px;\r\n  left: 50%;\r\n  z-index: 2;\r\n}\r\n\r\n.stepper-item .step-counter {\r\n  position: relative;\r\n  z-index: 5;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  background: #ccc;\r\n  margin-bottom: 6px;\r\n  .content{\r\n    justify-content: left;\r\n    align-items: start;\r\n  }\r\n}\r\n\r\n\r\n\r\n.stepper-item.active {\r\n  font-weight: bold;\r\n}\r\n\r\n.stepper-item.Success .step-counter {\r\n  background-color: #4bb543;\r\n}\r\n\r\n.stepper-item.Success::after {\r\n  position: absolute;\r\n  content: \"\";\r\n  border-bottom: 3px solid #4bb543;\r\n  width: 100%;\r\n  top: 39px;\r\n  left: 50%;\r\n  z-index: 3;\r\n}\r\n.stepper-item.Inprogress .step-counter {\r\n  background-color: goldenrod;\r\n}\r\n\r\n.stepper-item.Inprogress::after {\r\n  position: absolute;\r\n  content: \"\";\r\n  border-bottom: 3px solid goldenrod;\r\n  width: 100%;\r\n  top: 39px;\r\n  left: 50%;\r\n  z-index: 3;\r\n}\r\n.stepper-item.Failed .step-counter {\r\n  background:red;\r\n}\r\n\r\n.stepper-item.Failed::after {\r\n  position: absolute;\r\n  content: \"\";\r\n  border-bottom: 3px solid red;\r\n  width: 100%;\r\n  top: 39px;\r\n  left: 50%;\r\n  z-index: 3;\r\n}\r\n\r\n.stepper-item:first-child::before {\r\n  content: none;\r\n}\r\n.stepper-item:last-child::after {\r\n  content: none;\r\n}\r\n\r\n.dialog-background {\r\n  background-color: gray;\r\n  opacity: .2 !important;\r\n}\r\n\r\n\r\n.list_item{\r\n  width: 85%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
